export default __webpack_public_path__ + "static/media/learningIllustration.47d7202f.png";